export default function updateDictionaryStade({de, en}) {
	if (de) {
		de['ui.feature-list.sorting.byDistance'] = '';
		de['ui.feature-list.sorting.choose'] = 'Sortieren nach Entfernung von ...';

		de['stade.tour.start'] = 'Tour starten!';
		de['stade.tour.startshort'] = 'Los!';
		de['stade.tour.next'] = 'nächster';
		de['stade.tour.prev'] = 'vorheriger';
		de['stade.tour.getBack'] = 'Tour fortsetzen!';

		de['stade.list.heading'] = 'Liste der Stationen';
		de['stade.list.moreHeading'] = 'Liste weiterer interessanter Orte';
		de['stade.list.toMore'] = 'Alle anderen interessanten Orte anzeigen';
		de['stade.list.toList'] = 'Liste der Stationen anzeigen';

		de['stade.map.heading'] = 'Karte der Stationen';
		de['stade.impressions.heading'] = 'Impressionen';
		de['stade.impressions.subheading'] = 'Bilder dieses Orts';

		de['stade.text.more.caption'] = 'Mehr erfahren';
		de['stade.text.more.text'] = 'Weitere Infromationen finden sich';
		de['stade.text.more.link'] = 'hier';
		de['stade.text.error404'] = 'Die von Ihnen abgerufene Seite gibt es nicht.';

		de['stade.footer'] = 'Seitenfuß';
	}

	if (en) {
		en['ui.feature-list.sorting.byDistance'] = '';
		en['ui.feature-list.sorting.choose'] = 'Sort by distance from ...';

		en['stade.tour.start'] = 'Start the tour!';
		en['stade.tour.startshort'] = 'Go!';
		en['stade.tour.next'] = 'next';
		en['stade.tour.prev'] = 'previous';
		en['stade.tour.getBack'] = 'Continue the tour!';

		en['stade.list.heading'] = 'List of places';
		en['stade.list.moreHeading'] = 'List of other points of interest';
		en['stade.list.toMore'] = 'Show list of other points of interest';
		en['stade.list.toList'] = 'Show list of tour';

		en['stade.map.heading'] = 'Map of places';
		en['stade.impressions.heading'] = 'Impressions';
		en['stade.impressions.subheading'] = 'Pictures of this place';

		en['stade.text.more.caption'] = 'More about this';
		en['stade.text.more.text'] = 'You\'ll find further information';
		en['stade.text.more.link'] = 'here';
		en['stade.text.error404'] = 'The requested page does not exist.';

		en['stade.footer'] = 'Page Footer';
	}
}
